import { css } from '@emotion/css';

export const listItemImageStyles = (height: number, width: number) => css`
  height: ${height}rem;
  width: ${width}rem;
  min-height: ${height}rem;
  min-width: ${width}rem;
`;
